import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const { Search } = Input;

export default function FiltroCarpetas({ searchTerm, onSearchChange }) {
  return (
    <div style={{ width: "100%" }}>
      <Search
        placeholder="Buscar carpetas..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        allowClear
        enterButton={false}
        size="middle"
        style={{ width: "100%" }}
        prefix={<SearchOutlined style={{ color: "#999" }} />}
      />
    </div>
  );
}
